import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setError } from "../../redux/slices/ui";
import Modal from "./Modal";
import Button from "./Button";

const Error = () => {
  const dispatch = useDispatch();
  const { show, message } = useSelector((state) => state.ui.error);
  const close = () => dispatch(setError({ show: false }));

  return (
    <Modal
      open={!!show}
      onClose={close}
      title="Σφάλμα"
      footer={
        <Button variant="secondary" onClick={close}>
          Κλείσιμο
        </Button>
      }
    >
      <p className="py-2 text-slate-700">{String(message ?? "")}</p>
    </Modal>
  );
};

export default Error;
